export default "__VITE_ASSET__31356dd2__"